export const START_AUTH_USER = 'START_AUTH_USER';
export const FINISH_AUTH_USER = 'FINISH_AUTH_USER';
export const ERROR_AUTH_USER = 'ERROR_AUTH_USER';

export const START_LOAD_PROFILE = 'START_LOAD_PROFILE';
export const FINISH_LOAD_PROFILE = 'FINISH_LOAD_PROFILE';
export const ERROR_LOAD_PROFILE = 'ERROR_LOAD_PROFILE';

export const START_UPDATE_PROFILE = 'START_UPDATE_PROFILE';
export const FINISH_UPDATE_PROFILE = 'FINISH_UPDATE_PROFILE';
export const ERROR_UPDATE_PROFILE = 'ERROR_UPDATE_PROFILE';

export const START_ADD_DEVICE = 'START_ADD_DEVICE';
export const ERROR_ADD_DEVICE = 'ERROR_ADD_DEVICE';
export const FINISH_ADD_DEVICE = 'FINISH_ADD_DEVICE';

export const START_SEND_FEEDBACK = 'START_SEND_FEEDBACK';
export const FINISH_SEND_FEEDBACK = 'FINISH_SEND_FEEDBACK';
export const ERROR_SEND_FEEDBACK = 'ERROR_SEND_FEEDBACK';


// WEBPACK FOOTER //
// ./src/models/user/constants.js